export default "__VITE_ASSET__df9c2e96__"